'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function IconFirst(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: color, height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M16.84,17.68025 C16.58,17.68025 16.33,17.58325 16.13,17.38725 L11.29,12.54725 C11.1,12.35925 11,12.10525 11,11.84025 C11,11.57525 11.1,11.32025 11.29,11.13325 L16.13,6.29325 C16.52,5.90225 17.15,5.90225 17.55,6.29325 C17.94,6.68425 17.94,7.31725 17.55,7.70725 L13.41,11.84025 L17.55,15.97325 C17.94,16.36325 17.94,16.99725 17.55,17.38725 C17.35,17.58325 17.09,17.68025 16.84,17.68025' }),
      ' ',
      _react2.default.createElement('path', { d: 'M11.84,17.68025 C11.58,17.68025 11.33,17.58325 11.13,17.38725 L6.29,12.54725 C6.1,12.35925 6,12.10525 6,11.84025 C6,11.57525 6.1,11.32025 6.29,11.13325 L11.13,6.29325 C11.52,5.90225 12.15,5.90225 12.55,6.29325 C12.94,6.68425 12.94,7.31725 12.55,7.70725 L8.41,11.84025 L12.55,15.97325 C12.94,16.36325 12.94,16.99725 12.55,17.38725 C12.35,17.58325 12.09,17.68025 11.84,17.68025' }),
      ' '
    )
  );
}

IconFirst.propTypes = {
  color: _propTypes2.default.string
};

IconFirst.defaultProps = {
  color: _colors2.default.icons
};

IconFirst.displayName = 'IconFirst';

exports.default = IconFirst;
module.exports = exports.default;